import { render, staticRenderFns } from "./Particulier.vue?vue&type=template&id=1b499e3b&scoped=true&"
import script from "./Particulier.vue?vue&type=script&lang=js&"
export * from "./Particulier.vue?vue&type=script&lang=js&"
import style0 from "./Particulier.vue?vue&type=style&index=0&id=1b499e3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b499e3b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/lauprvo/Documents/Veloshop2.0/veloshop2/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VFooter } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer,VDataTable,VDivider,VFlex,VFooter,VIcon,VLayout,VTab,VTabs})
